<template>
  <div
    class="dea-card-resource dea-card-resource--compact dea-card-resource--bookmark"
    :class="[[`dea-card-resource--${accentModifier}`]]"
  >
    <div v-if="origin" class="dea-card-resource__badge-container" :title="originLabel">
      <div :class="`dea-card-resource__badge ${badgeAccentModifier} dea-card-resource__badge--${badgeEmptyModifier}`">
        <span class="dea-heading--regular-xxs">{{ originLabel }}</span>
      </div>
    </div>
    <div class="dea-card-resource__wrapper">
      <div class="dea-card-resource__content">
        <div class="dea-card-resource__card-header">
          <div class="dea-card-resource__card-header--left">
            <div>
              <div v-if="tag1List.length" class="dea-card-resource__tag">
                <template v-for="(tag, index) in tag1List">
                  <template v-if="index > 0">,&nbsp; </template>
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span :key="`tag1-${index}`" class="dea-heading--medium-xs" v-html="tag"></span
                ></template>
              </div>
              <a class="dea-links dea-links--pointer" :href="resource.share_url" target="_blank">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="dea-card-resource__title" v-html="title"></div>
              </a>
            </div>
          </div>

          <CardResourceActionButtons
            :resource="resource"
            :show-image="false"
            :show-type-icon="true"
            :layout="layout"
            :icon-accent-class="iconAccentClass"
            :action-accent-class="actionAccentClass"
            :teachers-only="false"
            :show-teacher-label="false"
            :is-locked="false"
            :share-enabled="sharePermittedForFormats"
            :bookmark-enabled="true"
            :bookmark-button-status="bookmarkButtonStatus"
            @delete-bookmark="deleteBookmark"
            @save-bookmark="saveBookmark"
            @dropdown-toggled="$emit('dropdown-toggled', $event)"
          >
          </CardResourceActionButtons>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardResourceActionButtons from "deascuola-storybook/src/components/patterns/CardResourceActionButtons";
import ResourceClient from "dea-bookmarks-clients/src/clients/resources";

export default {
  name: "CardBookmark",
  components: { CardResourceActionButtons },
  props: {
    bookmark: {
      type: Object,
      required: true,
    },
    /**
     * Modifier code to change the accent color of the resource type icon. Possible values "docenti", "za", "zm", "zs", "studenti", "famiglie"
     */
    accentModifier: {
      type: String,
      default: "docenti",
    },
    /**
     * Modifier code to change the accent color on the action buttons. Possible values "docenti", "za", "zm", "zs", "studenti", "famiglie"
     */
    actionAccentModifier: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      layout: "compressed",
      shareDisabledFormats: this.$root.config.shareDisabledFormats
        ? this.$root.config.shareDisabledFormats
        : ["modulo_google"],
    };
  },
  computed: {
    /**
     * Check every type format against the list in shareDisabledFormats (which can be overwritten by setting shareDisabledFormats in appConf.js)
     */
    sharePermittedForFormats() {
      return this.resource.type_format.filter(format => this.shareDisabledFormats.indexOf(format) === -1).length > 0;
    },
    origin() {
      if (this.bookmark) return this.bookmark.data_from;
      return "";
    },
    badgeAccentModifier() {
      if (this.origin && this.origin.code !== "sitolibro") return `dea-bg-target-${this.origin.code}`;
      return `dea-card-resource__badge--${this.accentModifier}`;
    },
    originLabel() {
      if (this.origin) {
        return this.origin.label;
      }
      return "";
    },
    badgeEmptyModifier() {
      return !this.originLabel ? "empty" : "";
    },
    title() {
      return this.bookmark.title;
    },
    tag1List() {
      if (this.bookmark.type === ResourceClient.typeEvent) return [this.bookmark.payload.type_label];
      if (this.bookmark.type === ResourceClient.typeLink)
        return this.bookmark.payload.categories.map(item => item.name);
      if (this.bookmark.type === ResourceClient.typeResources) return [this.bookmark.payload.type_label];
      return [];
    },
    iconAccentClass() {
      return `dea-card-resource__icon--${this.accentModifier}`;
    },
    actionAccentClass() {
      return `dea-card-resource__button--${this.actionAccentModifier}`;
    },
    resource() {
      const data = { ...this.bookmark.payload };
      data.buttonsActive = true;
      data.share_url = this.bookmark.data_url;
      return data;
    },
    bookmarkButtonStatus() {
      return Boolean(this.bookmark);
    },
  },
  mounted() {
    try {
      // eslint-disable-next-line no-undef
      if (gapi) gapi.sharetoclassroom.go("dea-buttons-share");
    } catch {
      // eslint-disable-next-line no-unused-expressions
      null;
    }
    try {
      // eslint-disable-next-line no-undef
      if (shareToMicrosoftTeams) shareToMicrosoftTeams.renderButtons();
    } catch {
      // eslint-disable-next-line no-unused-expressions
      null;
    }
  },
  methods: {
    saveBookmark() {
      this.$emit("save-bookmark", this.resource);
    },
    deleteBookmark() {
      this.$emit("delete-bookmark", this.bookmark);
      this.showConfirmDelete = false;
    },
  },
};
</script>

<style lang="scss">
.dea-card-resource--bookmark {
  .dea-card-resource__title {
    cursor: pointer;
  }
}
</style>
